import React, { useState, useEffect } from 'react';
import AdminDashboard from './AdminDashboard';
import Swal from 'sweetalert2';
import axios from 'axios';
import '../../assets/css/admin/allcourses.css';

const AllEvents = () => {
    const [events, setEvents] = useState([]);
    const [searchTerm, setSearchTerm] = useState('');
    const [filteredEvents, setFilteredEvents] = useState([]);

    useEffect(() => {
        fetchEvents();
    }, []);

    const fetchEvents = async () => {
        try {
            const response = await fetch('https://api.myskills.lk/events/all');
            const data = await response.json();
            setEvents(data);
            setFilteredEvents(data); // Initialize filteredEvents with all events
        } catch (error) {
            console.error('Error fetching events:', error);
        }
    };

    // Real-time filtering effect
    useEffect(() => {
        if (!searchTerm.trim()) {
            // If search is empty, show all events
            setFilteredEvents(events);
            return;
        }
        
        // Filter events based on multiple fields
        const filtered = events.filter(event => 
            (event.eventName && event.eventName.toLowerCase().includes(searchTerm.toLowerCase())) ||
            (event.university && event.university.toLowerCase().includes(searchTerm.toLowerCase())) ||
            (event.venue && event.venue.toLowerCase().includes(searchTerm.toLowerCase())) ||
            (event.time && event.time.toLowerCase().includes(searchTerm.toLowerCase()))
        );
        
        setFilteredEvents(filtered);
    }, [searchTerm, events]);

    const handleSearch = (e) => {
        setSearchTerm(e.target.value);
    };

    const handleDelete = (e, eventId) => {
        e.preventDefault();
        console.log(eventId);

        Swal.fire({
            title: "Are you sure?",
            text: "Do you want to delete this event?",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            confirmButtonText: "Yes, delete it!"
        }).then((result) => {
            if (result.isConfirmed) {
                axios.post(`https://api.myskills.lk/events/delete/${eventId}`)
                    .then((response) => {
                        // Update local state after successful deletion
                        const updatedEvents = events.filter(event => event.id !== eventId);
                        setEvents(updatedEvents);
                        
                        // Also update filtered events
                        setFilteredEvents(updatedEvents.filter(event => 
                            !searchTerm || 
                            (event.eventName && event.eventName.toLowerCase().includes(searchTerm.toLowerCase())) ||
                            (event.university && event.university.toLowerCase().includes(searchTerm.toLowerCase())) ||
                            (event.venue && event.venue.toLowerCase().includes(searchTerm.toLowerCase())) ||
                            (event.time && event.time.toLowerCase().includes(searchTerm.toLowerCase()))
                        ));
                        
                        // Show success message
                        Swal.fire({
                            title: "Deleted!",
                            text: "The event has been deleted.",
                            icon: "success"
                        });
                    })
                    .catch((err) => {
                        console.error("Error deleting event:", err);
                        Swal.fire({
                            title: "Error!",
                            text: "Failed to delete the event.",
                            icon: "error"
                        });
                    });
            }
        });
    };


    return (
        <div>
            <AdminDashboard />

            <div className='AllViews-admin-course'>
                <div className="search-icon-admin admin-course-search">
                    <h1>ALL EVENTS</h1>
                    <form>
                        <input 
                            type="text" 
                            value={searchTerm}
                            onChange={handleSearch}
                            placeholder='Search Item' 
                        />
                        <input type="submit" value="SEARCH" onClick={(e) => e.preventDefault()} />
                    </form>
                </div>

                <div className="scroller-box">
                    <div className="table-course">
                    <table>
                            <thead>
                                <tr>
                                    <th>Event Name</th>
                                    <th>University Name</th>
                                    <th>Venue</th>
                                    <th>Date</th>
                                    <th>Time</th>
                                    <th>View</th>
                                    <th>Action</th>
                                </tr>
                            </thead>
                            <tbody>
                                {filteredEvents.length > 0 ? (
                                    filteredEvents.map((eventItem) => (
                                        <tr key={eventItem.id}>
                                            <td>{eventItem.eventName}</td>
                                            <td>{eventItem.university}</td>
                                            <td>{eventItem.venue}</td>
                                            <td>{eventItem.date ? new Date(eventItem.date).toLocaleDateString('en-CA') : ''}</td>
                                            <td>{eventItem.time}</td>
                                            <td><a href={eventItem.link} target="_blank" rel="noopener noreferrer" id='view-website'>Link</a></td>
                                            <td id='action-buttons'>
                                                <a href="#!" id='del-details' onClick={(e) => handleDelete(e, eventItem.id)}>DELETE</a>
                                            </td>
                                        </tr>
                                    ))
                                ) : (
                                    <tr>
                                        <td colSpan="7" style={{textAlign: 'center'}}>No events found matching your search</td>
                                    </tr>
                                )}
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default AllEvents;
